module.exports = __webpack_public_path__ + "img/CN.8de10fef.png";